import styles from './index.module.css';
import logo from '../../assets/powered-by-notable-logo.png';

const Footer: React.FC = () => (
  <footer className={styles.Footer}>
    <img className={styles.Logo} src={String(logo)} alt="notable logo" />
  </footer>
);

export default Footer;
